import { render, staticRenderFns } from "./MedicalHeader.vue?vue&type=template&id=5bfea806&scoped=true"
import script from "./MedicalHeader.vue?vue&type=script&lang=js"
export * from "./MedicalHeader.vue?vue&type=script&lang=js"
import style0 from "./MedicalHeader.vue?vue&type=style&index=0&id=5bfea806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfea806",
  null
  
)

export default component.exports